import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'

/* Utilities */
import _ from 'lodash'

/* Widgets */
import TextInput from 'widget/text-input'
import TagInput from 'widget/tag-input'
import DropdownButton from 'widget/dropdown-button'
import { Highlight, MODE as HIGHLIGHT_MODE } from 'widget/highlight'
import Thumbnail from 'widget/thumbnail'
import InfoText from 'widget/info-text'
import {
  RemoveDialog,
  SCHEME as REMOVE_DIALOG_SCHEME
} from 'widget/remove-dialog'
import { Icon, ICON, SCHEME as ICON_SCHEME } from 'widget/icon'

/* Components */
import AssetPreview from './preview'

/* Actions */
import { showModal, hideModal } from 'react-redux/actions/modal'
import {
  saveName,
  saveTags,
  deleteSingleItem
} from 'react-redux/actions/asset'
import { select, toggleSelect, setSelect, toggleActive, setActive } from 'react-redux/actions/highlight'
import { startDrag, stopDrag } from 'react-redux/actions/drag-and-drop'

/* Selectors */
import { getItem } from 'react-redux/selectors/asset'

/* Styles */
import "./item.css"

/* Single Asset Item shown in asset list */
class AssetItem extends Component {

  constructor() {
    super()
    this.state = {
      removeCommit: false,
      dragging: false
    }
  }

  componentDidMount() { }

  componentWillReceiveProps(nextProps) { }

  onAssetPreview(e) {
    const { showModal, uid, setActive } = this.props
    //e.stopPropagation() // prevent event from deselecting item
    //setActive("asset", uid)
    //onSelect(e)
    showModal(<AssetPreview uid={ uid }/>)
  }

  onFocusPreview() {
    const { setActive, uid } = this.props
    //setActive("asset", uid)
  }

  onSaveName(value) {
    const { uid, saveName } = this.props
    saveName(uid, value)
  }

  onEditName() {
    const { setActive, uid } = this.props
  //  setActive("asset", uid)
  }

  onSaveTags(tags) {
    const { uid, saveTags } = this.props
    saveTags(uid, tags)
  }

  onEditTags() {
    const { setActive, uid } = this.props
    //setActive("asset", uid)
  }

  onRemoveClick(e) {
    const { uid } = this.props
    e.stopPropagation()
    this.setState({
      removeCommit: true
    })
  }

  onBlur(e) {

  }

  onRemoveCommitMouseDown(e) {
    e.preventDefault()
    e.stopPropagation()
  }

  onRemoveCommitBackgroundClick(e) {
    e.preventDefault()
    e.stopPropagation()
  }

  onRemoveCommitClick(e) {
    const { deleteSingleItem, uid } = this.props
    e.stopPropagation()
    deleteSingleItem(uid)
  }

  onRemoveCancelClick(e) {
    e.stopPropagation()
    this.setState({
      removeCommit: false
    })
  }


  validateName(value) {
    return value && value.length
  }

  isActive() {
    const { domain, uid } = this.props.highlight.active
    return domain === "asset" && uid === this.props.uid
  }

  isSelected() {
    const { selected } = this.props.highlight
    return !!_.find(selected, {domain:"asset", uid: this.props.uid})
  }

  isAscendant() {
    const { ascendants } = this.props.highlight
    return ascendants["asset"] && ascendants["asset"][this.props.uid]
  }

  isDescendant() {
    const { descendants } = this.props.highlight
    return descendants["asset"] && descendants["asset"][this.props.uid]
  }

  getListItemClass() {
    const {  } = this.props
    var className = "asset-item component"
    if (this.isSelected()) className += " selected"
    if (this.isActive()) className += " highlight-selected"
    else if (this.isAscendant()) className += " highlight-ascendant"
    else if (this.isDescendant()) className += " highlight-descendant"
    if (this.state.dragging) className += " dragging"
    return className
  }

  getHighlightMode() {
    const {  } = this.props
    if (this.isActive()) return  HIGHLIGHT_MODE.SELECTED
    else if (this.isAscendant()) return  HIGHLIGHT_MODE.CHILD
    else if (this.isDescendant()) return  HIGHLIGHT_MODE.PARENT
  }

  getThumnailSrc() {
    const { uid, thumbnail, raw } =  this.props
    if (thumbnail) return thumbnail.url
    if (raw) return raw.url
  }

  renderRemoveButton() {
    const { usageCount, t } = this.props
    if(usageCount>0) return (
      <button
        className="usage"
        title={ t("asset:item.noRemove")}
      >
        <Icon icon={ ICON.PROHIBITED } size={ 24 } circle={ false } />
      </button>
    )
    return (
      <button
        title={ t("asset:item.remove")}
        onClick={ this.onRemoveClick.bind(this) }
      >
        <Icon icon={ ICON.DELETE } size={ 24 } circle={ false } />
      </button>
    )
  }

  getToolbarItems() {
    const { t, usageCount, fileName }  = this.props
    let items = []
    if(usageCount==0) {
      items.push(
        {
          name: t("asset:item.remove"),
          title: t("asset:item.remove"),
          icon: ICON.DELETE,
          iconScheme: ICON_SCHEME.DANGER,
          onClick: this.onRemoveClick.bind(this)
        }
      )
    } else {
      items.push({
        name: t("asset:item.noRemove"),
        title: t("asset:item.noRemove"),
        icon: ICON.PROHIBITED,
        iconScheme: ICON_SCHEME.WARNING,
      })
    }
    items.push({ type: "seperator" })
    items.push({
      name: fileName,
      title:  t("asset:item.fileNameTitle"),
      style: "info"
    })
    return items
  }

  renderItemToolbar() {
    const { t, syncHint } = this.props
    return (
      <span className="toolbar">
        <DropdownButton
          title={ t('asset:item.menuTitle') }
          menu={ { items:this.getToolbarItems() } }
        />
      </span>
    )
  }

  onDragStart(e) {
    const {
      uid,
      startDrag
    } = this.props
    this.nameInput.inputElement.blur()
    this.setState({ dragging: true })
    e.stopPropagation()
    e.dataTransfer.setData('text', JSON.stringify({ uid, domain:'asset' }))
    startDrag('asset', uid )
  }

  onDragEnd(e) {
    this.setState({ dragging: false })
    e.stopPropagation()
  }

  renderRemoveCommit() {
    const { t, name, fileName } = this.props
    const { removeCommit } = this.state
    if (!removeCommit) return null
    return (
      <RemoveDialog
        text={ t("asset:item.removeDialog.text", { name: name || fileName } )}
        scheme={ REMOVE_DIALOG_SCHEME.REMOVE }
        onCancel={ this.onRemoveCancelClick.bind(this) }
        cancelLabel={ t("asset:item.removeDialog.cancelButtonLabel") }
        onConfirm={ this.onRemoveCommitClick.bind(this) }
        confirmLabel={ t("asset:item.removeDialog.confirmButtonLabel") }
      />
    )
  }

  onSelect(e) {
    const {
      t,
      uid,
      toggleActive,
      toggleSelect,
      setSelect,
      setActive
    } = this.props
    setActive("asset", uid)
    if (e.ctrlKey || e.shiftKey) toggleSelect("asset", uid)
    else setSelect("asset", uid)

  }

  /**
  * Render Asset Items as list elements
  */
  render() {
    const {
      t,
      uid,
      name,
      fileName,
      toggleActive,
      toggleSelect,
      setSelect,
      setActive,
      tags,
      pending
    } = this.props
    if (pending) {
      return (
        <li
          className={ this.getListItemClass() }
          key={ uid }
          data-uid={ uid }
        >
          loading
        </li>
      )
    }
    return (
      <li
        className={ this.getListItemClass() }
        key={ uid }
        data-uid={ uid }
        onClick={ this.onSelect.bind(this) }
        draggable="true"
        onDragStart={ this.onDragStart.bind(this) }
        onDragEnd={ this.onDragEnd.bind(this) }
        onBlur={ this.onBlur.bind(this) }
      >
        <div className="border">
          <div className="detail">
            <Highlight mode={ this.getHighlightMode() } />
            <Thumbnail
              src={ this.getThumnailSrc() }
              title={ t("asset:item.preview") }
              onFocus={ this.onFocusPreview.bind(this) }
              onClick={ this.onAssetPreview.bind(this) }
              />
            <div className="label">
              <TextInput
                ref={ (elem) => { this.nameInput=elem  }}
                className="name"
                value={ name }
                placeholder={ t('asset:item.nameInput.placeholder') }
                onSave={ this.onSaveName.bind(this) }
                onEdit={ this.onEditName.bind(this) }
                validate={ this.validateName.bind(this) }
                clearTitle={ t("input:clearTitle")}
                resetTitle={ t("input:resetTitle")}
                saveTitle={ t("input:saveTitle")}
              />
              <TagInput
                value={ tags }
                placeholder={ t('asset:item.tagInput.placeholder') }
                onSave={ this.onSaveTags.bind(this) }
                onEdit={ this.onEditTags.bind(this) }
                clearTitle={ t("input:clearTitle")}
                resetTitle={ t("input:resetTitle")}
                saveTitle={ t("input:saveTitle")}
              ></TagInput>
            </div>
            { this.renderItemToolbar() }
          </div>
        </div>
        { this.renderRemoveCommit() }
      </li>
    )
  }
}

AssetItem.propTypes = {
    uid: PropTypes.string.isRequired,
}

function mapStateToProps(state) {
    return state
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showModal,
      hideModal,
      saveName,
      saveTags,
      deleteSingleItem,
      startDrag,
      stopDrag,
      toggleActive,
      toggleSelect,
      setSelect,
      setActive
    },
    dispatch
  )
}

function mergeProps(stateProps, dispatchProps, ownProps){
  return Object.assign(
    {},
    dispatchProps,
    getItem(stateProps, ownProps.uid),
    { highlight: stateProps.highlight },
    ownProps
  )
}

const reduxComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(AssetItem)
const translatedComponent = translate([], { withRef: true })(reduxComponent)
export default translatedComponent



// WEBPACK FOOTER //
// ./src/app/component/asset/item.jsx